import React from 'react';
import {Link} from "react-router-dom";

const AdminPortal = () => {
    return (
        <div>
            <nav>
                <ul>
                    <li>
                        <Link to="/admin/partners">Partners Management</Link>
                    </li>
                    <li>
                        <Link to="/admin/agreements">Partnership agreements</Link>
                    </li>
                </ul>
            </nav>

        </div>
    );
};

export default AdminPortal;
